<template>
  <div>
    <vs-row vs-type="flex" class="mt-0 mb-4" vs-justify="center" vs-align="center" vs-w="12">
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="12">
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          size="small"
          label="Data De"
          v-model="filtro.dataDe"
        ></vs-input>
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          label="Data Até"
          size="small"
          v-model="filtro.dataAte"
        ></vs-input>
        <div>
          <label style="color: black; font-size: 0.85rem" class="pl-2">Tipo da Data</label>
          <br />
          <el-select
            filterable
            size="small"
            clearable
            placeholder="Selecione"
            v-model="filtro.tipoData"
            class="mx-1"
          >
            <el-option v-for="data in tipoDatas" :value="data.id" :label="data.nome" :key="data.id"></el-option>
          </el-select>
        </div>
        <vs-input
          color="dark"
          class="mx-1"
          size="small"
          type="text"
          placeholder
          label="Busca"
          v-model="filtro.busca"
        ></vs-input>
        <div>
          <label style="color: black; font-size: 0.85rem" class="pl-2">Colaborador</label>
          <br />
          <el-select
            filterable
            clearable
            remote
            size="small"
            :remote-method="filtroColaborador"
            placeholder="Pesquise"
            loading-text="Buscando..."
            :loading="loading"
            v-model="filtro.colaborador"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="colaborador in colaboradores"
              :value="colaborador.id"
              :label="colaborador.nome"
              :key="colaborador.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <label style="color: black; font-size: 0.85rem" class="pl-2">Tipo do Assunto</label>
          <br />
          <el-select
            filterable
            size="small"
            clearable
            placeholder="Selecione"
            v-model="filtro.tipoAssunto"
            class="mx-1"
          >
            <el-option
              v-for="assunto in tipoAssuntos"
              :value="assunto.id"
              :label="assunto.nome"
              :key="assunto.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <label style="color: black; font-size: 0.85rem" class="pl-2">Estagio</label>
          <br />
          <el-select
            size="small"
            filterable
            clearable
            placeholder="Selecione"
            v-model="filtro.estagio"
            class="mx-1"
          >
            <el-option
              v-for="estagio in estagios"
              :value="estagio.id"
              :label="estagio.nome"
              :key="estagio.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <label style="color: black; font-size: 0.85rem" class="pl-2">Status</label>
          <br />
          <el-select
            size="small"
            filterable
            clearable
            placeholder="Selecione"
            v-model="filtro.status"
            class="mx-1"
          >
            <el-option
              v-for="status in statuses"
              :value="status.value"
              :label="status.nome"
              :key="status.id"
            ></el-option>
          </el-select>
        </div>
        <el-button size="small" type="primary" class="mx-1" plain @click="getAssuntos()">FILTRAR</el-button>
        <el-button
          v-if="$atividades && $atividades.permissoes && $atividades.permissoes.includes(20)"
          size="small"
          type="success"
          class="mx-1"
          style="color: white !important;"
          @click="modalConfiguracao = true"
        >CONFIGURAR GATILHOS WATI</el-button>
      </vs-col>
    </vs-row>
    <div id="assunto" class="cardTable mb-1 vs-con-loading__container">
      <div v-if="assuntos.length == 0">
        <div class="pt-20 scroll-assunto con-colors">
          <ul class="pt-20">
            <li class="danger-box">
              <h2 class="p-5" style="color: white !important">Nenhum Assunto</h2>
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="mt-1">
        <VuePerfectScrollbar class="scroll-assunto" :settings="settings">
          <vs-table maxHeight="63vh" stripe max-items="10" pagination :data="assuntos">
            <template slot="thead">
              <vs-th sort-key="id_contrato" style="width: 5%" id="center">Contrato</vs-th>
              <vs-th sort-key="id_colaborador" style="width: 12%">Cliente</vs-th>
              <vs-th style="width: 10%" id="center">Telefone</vs-th>
              <vs-th sort-key="id_colaborador" style="width: 13%">Colaborador</vs-th>
              <vs-th sort-key="id_assuntos" style="width: 13%">Assunto</vs-th>
              <vs-th style="width: 10%" id="center">Status</vs-th>
              <vs-th style="width: 15%" id="center">Cadastro / T. Resposta</vs-th>
              <vs-th style="width: 7%" id="center">Lembrete</vs-th>
              <vs-th style="width: 15%" id="center">Observação</vs-th>
              <vs-th style="width: 5%" id="center">Respostas</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(tr, index) in data">
                <vs-td :data="tr.id_contrato" class="text-center">
                  <a
                    v-if="tr.id_contrato > 0"
                    :href="'contrato?id=' + tr.id_contrato"
                    style="font-size: 12px; color: darkblue; cursor: pointer"
                  >
                    <b>{{ tr.id_contrato > 0 ? tr.id_contrato : "..." }}</b>
                  </a>
                </vs-td>                <vs-td :data="tr.nomeCliente"
                  class="font-semibold"
                  style="font-size: 12px"
                >{{ tr.nomeCliente }}</vs-td>
                <vs-td :data="tr.telefone" style="font-size: 12px">
                  {{ tr.telefone || "-" }}
                </vs-td>
                <vs-td
                  :data="tr.id_colaborador"
                  class="font-semibold"
                  style="font-size: 12px"
                >{{ tr.colaborador }}</vs-td>
                <vs-td :data="tr.id_assuntos" style="font-size: 12px">
                  {{
                  tr.assunto
                  }}
                </vs-td>
                <vs-td class="text-center">
                  <div class="w-full" @click="changeStatus(tr)" style="cursor: pointer">
                    <vs-row vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
                      <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
                        <Badge
                          :key="reRenderBadge"
                          :color="
                            tr.status == 0 || tr.status == '0'
                              ? '#0044f2'
                              : 'success'
                          "
                          :text="
                            tr.status == 0 || tr.status == '0'
                              ? 'Em processo'
                              : 'Concluido'
                          "
                        ></Badge>
                      </vs-col>
                    </vs-row>
                  </div>
                </vs-td>
                <vs-td class="text-center" style="font-size: 12px">
                  <div style="font-weight: 500;">{{ tr.data_criacao }}</div>
                  <div style="font-size: 10px; color: #64748b; margin-top: 2px;">{{ tr.horario_criacao }}</div>
                  <div v-if="tr.tempo_resposta !== null" style="font-size: 10px; color: #15803d; font-weight: 600; display: inline-flex; align-items: center; justify-content: center; gap: 3px; background-color: #f0fdf4; padding: 2px 6px; border-radius: 4px; border: 1px solid #dcfce7; white-space: nowrap; margin-top: 4px;">
                    <vs-icon icon="schedule" style="font-size: 11px;"></vs-icon>
                    {{ formatTempoResposta(tr.tempo_resposta) }}
                  </div>
                </vs-td>
                <vs-td class="text-center" style="font-size: 12px">{{ tr.data_marcada || "-" }}</vs-td>
                <vs-td style="font-size: 12px">{{ tr.obs }}</vs-td>
                <vs-td style="font-size: 12px">
                  <div class="w-full">
                    <vs-row vs-w="12" vs-type="flex" vs-align="center" vs-justify="center">
                      <vs-row vs-w="12" vs-type="flex" vs-align="center" vs-justify="center">
                        <vs-button
                          @click="openModalRespostas(tr)"
                          icon="question_answer"
                          size="small"
                          color="success"
                          type="relief"
                          radius
                        />
                      </vs-row>
                    </vs-row>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </VuePerfectScrollbar>
        <div class="mt-4 flex justify-between items-center" style="display: flex; justify-content: space-between; align-items: center; border: 1px solid #e2e8f0; border-radius: 8px; background: #ffffff; padding: 12px 20px; box-shadow: 0 1px 3px 0 rgba(0,0,0,0.05);">
          <!-- Left side: Total -->
          <div style="display: flex; align-items: center; gap: 10px;">
            <div style="display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 8px; background-color: #eff6ff;">
              <vs-icon icon="assessment" color="primary" style="font-size: 22px;"></vs-icon>
            </div>
            <div style="display: flex; flex-direction: column; align-items: flex-start;">
              <span style="font-size: 10px; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; line-height: 1;">Total de Assuntos</span>
              <span style="font-size: 16px; color: #1e293b; font-weight: 700; line-height: 1.2; margin-top: 2px;">{{ assuntos.length }}</span>
            </div>
          </div>

          <!-- Right side: Average response time -->
          <div style="display: flex; align-items: center; gap: 10px;">
            <div style="display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 8px; background-color: #f0fdf4;">
              <vs-icon icon="schedule" color="success" style="font-size: 22px;"></vs-icon>
            </div>
            <div style="display: flex; flex-direction: column; align-items: flex-end;">
              <span style="font-size: 10px; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; line-height: 1; white-space: nowrap;">Tempo Médio de Resposta</span>
              <span style="font-size: 16px; color: #15803d; font-weight: 700; line-height: 1.2; margin-top: 2px; white-space: nowrap;">{{ formatTempoResposta(tempoMedioResposta) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <component v-bind:is="modalRespostas" :key="reRenderModalRespostas" :assunto="selectedAssunto" />

    <vs-popup class="wati-config-popup" size="large" title="Configurar Envio / Chamados via WATI" :active.sync="modalConfiguracao" style="z-index: 52000;">
      <div id="modalConfigWati" class="p-6 vs-con-loading__container" style="max-height: 75vh; overflow-y: auto;">
        <!-- Configuração Global -->
        <div class="mb-6 p-4 rounded-lg" style="background: #f0fdf4; border: 1px solid #bbf7d0;">
          <h5 class="font-bold mb-2" style="color: #166534; font-size: 14px;">Configuração Geral do Sistema</h5>
          <div class="flex items-center justify-between" style="display: flex; align-items: center; justify-content: space-between;">
            <span style="font-size: 13px; color: #1e293b; font-weight: 500;">
              Ativar envio automático de mensagens via WATI na abertura de chamado
            </span>
            <vs-switch
              color="success"
              v-model="globalWati"
            />
          </div>
          <div class="flex items-center justify-between mt-4" style="display: flex; align-items: center; justify-content: space-between; margin-top: 16px;">
            <span style="font-size: 13px; color: #1e293b; font-weight: 500;">
              Ativar disparo automático de Pesquisa NPS via WATI (10 dias após OSs 2, 5, 10, 20)
            </span>
            <vs-switch
              color="success"
              v-model="enviarNpsWati"
            />
          </div>
          <div class="mt-4" v-if="enviarNpsWati" style="margin-top: 16px;">
            <label style="font-size: 12px; color: #1e293b; font-weight: 500;">Template WATI para NPS</label>
            <vs-input
              color="success"
              size="small"
              v-model="templateNpsWati"
              placeholder="Ex: pesquisa_nps"
              class="w-full mt-1"
              style="width: 100%; margin-top: 4px;"
            />
          </div>
        </div>

        <vs-divider border-style="dotted" class="font-bold mb-4" color="dark">
          Gatilhos por Tipo de Assunto
        </vs-divider>

        <p class="mb-4 text-xs" style="color: #64748b;">
          Selecione o comportamento do sistema para cada tipo de assunto ao ser cadastrado para um cliente.
        </p>

        <vs-table :data="tipoAssuntos" class="wati-config-table">
          <template slot="thead">
            <vs-th>Assunto</vs-th>
            <vs-th style="width: 120px; text-align: center;white-space: nowrap;">Abrir Chamado</vs-th>
            <vs-th style="width: 120px; text-align: center;white-space: nowrap;">Enviar Msg</vs-th>
            <vs-th style="min-width: 200px;" title="Esse valor deve ser configurado no WATI para ser enviado no sistema">
              <span style="display: flex; align-items: center; gap: 4px; cursor: help;">
                Template WATI (Opcional)
                <vs-icon icon="help_outline" size="small"></vs-icon>
              </span>
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <strong>{{ tr.nome }}</strong>
              </vs-td>
              <vs-td style="text-align: center; vertical-align: middle;">
                <div style="display: inline-flex; justify-content: center; width: 100%;">
                  <vs-switch 
                    color="success" 
                    v-model="tr.abrir_chamado_wati" 
                  />
                </div>
              </vs-td>
              <vs-td style="text-align: center; vertical-align: middle;">
                <div style="display: inline-flex; justify-content: center; width: 100%;">
                  <vs-switch 
                    color="success" 
                    v-model="tr.enviar_wati" 
                  />
                </div>
              </vs-td>
              <vs-td>
                <vs-input
                  color="success"
                  size="small"
                  v-model="tr.template_wati"
                  placeholder="Nome do template"
                  class="w-full"
                  title="Esse valor deve ser configurado no WATI para ser enviado no sistema"
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <!-- Footer de Ações -->
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-6" style="border-top: 1px solid #e2e8f0; padding-top: 16px; display: flex; justify-content: flex-end; gap: 12px;">
          <vs-button color="danger" type="flat" @click="modalConfiguracao = false">Cancelar</vs-button>
          <vs-button color="success" type="relief" icon="save" @click="salvarConfiguracao()">Salvar Configurações</vs-button>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

import modalRespostas from "./../contrato/components/modalRespostas";
import router from "../../../router";
export default {
  data() {
    return {
      modalConfiguracao: false,
      modalRespostas: "",
      reRenderModalRespostas: 0,
      selectedAssunto: {},
      assuntos: [],
      tempoMedioResposta: null,
      reRenderBadge: 1,
      colaboradores: [],
      tipoAssuntos: [],
      globalWati: true,
      enviarNpsWati: false,
      templateNpsWati: "",
      tipoDatas: [
        { id: 1, nome: "Criacao" },
        { id: 2, nome: "Lembrete" }
      ],

      estagios: [],
      statuses: [
        { id: 1, nome: "Em Processo", value: 0 },
        { id: 2, nome: "Concluído", value: 1 }
      ],
      loading: false,
      filtro: {
        dataHoje: this.$formartData.dataFiltro(),
        tipoData: 1
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8
      },
      reRender: 0
    };
  },
  methods: {
    async getAssuntos() {
      await this.$vs.loading({ container: "#assunto", scale: 0.6 });
      try {
        const response = await this.$http.post(`getAssuntos`, this.filtro);
        this.assuntos = response.assuntos;
        this.tempoMedioResposta = response.tempo_medio_resposta;
        this.reRenderBadge += 1;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };

      } finally {
        await this.$vs.loading.close("#assunto > .con-vs-loading");
      }
    },
    async getGlobalWatiConfig() {
      try {
        const res = await this.$http.get('parametro/1');
        this.globalWati = !!res.enviar_wati_abertura_chamado;
        this.enviarNpsWati = !!res.enviar_nps_wati;
        this.templateNpsWati = res.template_nps_wati || "";
      } catch (err) {
        console.error(err);
      }
    },
    async salvarConfiguracao() {
      if (!this.$atividades || !this.$atividades.permissoes || !this.$atividades.permissoes.includes(20)) {
        this.$vs.notify({
          title: 'Acesso negado',
          text: 'Você não tem permissão para alterar as configurações do WATI.',
          color: 'danger'
        });
        return;
      }
      await this.$vs.loading({ container: "#modalConfigWati", scale: 0.6 });
      try {
        const promises = this.tipoAssuntos.map(assunto => {
          return this.$http.put(`assunto/${assunto.id}`, {
            abrir_chamado_wati: assunto.abrir_chamado_wati ? 1 : 0,
            enviar_wati: assunto.enviar_wati ? 1 : 0,
            template_wati: assunto.template_wati
          });
        });
        promises.push(this.$http.put('parametro/1', {
          enviar_wati_abertura_chamado: this.globalWati,
          enviar_nps_wati: this.enviarNpsWati ? 1 : 0,
          template_nps_wati: this.templateNpsWati
        }));
        await Promise.all(promises);
        this.$vs.notify({
          title: 'Sucesso',
          text: 'Configurações do WATI salvas com sucesso!',
          color: 'success'
        });
        this.modalConfiguracao = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close("#modalConfigWati > .con-vs-loading");
      }
    },
    async getTipoAssuntos() {
      try {
        const res = await this.$http.get(`listar-assuntos`);
        this.tipoAssuntos = res.map(item => ({
          ...item,
          abrir_chamado_wati: !!item.abrir_chamado_wati,
          enviar_wati: !!item.enviar_wati,
          template_wati: item.template_wati || ''
        }));
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getColaboradoresByQuery(query) {
      try {
        this.colaboradores = await this.$http.post(`getColaboradorByQuery`, {
          query: query
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async filtroColaborador(query) {
      if (query.length > 2) {
        this.loading = true;
        try {
          await this.getColaboradoresByQuery(query);
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
        } finally {
          this.loading = false;
        }
      }
    },
    async getEstagios() {
      try {
        this.estagios = await this.$http.get(`contrato_estagio`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async changeStatus(doc) {
      await this.$vs.loading({ container: "#assunto", scale: 0.6 });
      try {
        await this.$http.post("markLembreteAsRead", {
          id: doc.id,
          status: !doc.status
        });
        await this.getAssuntos();
        this.reRenderBadge += 1;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$vs.loading.close("#assunto > .con-vs-loading");
      }
    },
    async openModalRespostas(assunto) {
      this.selectedAssunto = assunto;
      this.modalRespostas = "modalRespostas";
      this.reRenderModalRespostas += 1;
    },
    formatTempoResposta(segundos) {
      if (segundos === null || segundos === undefined) {
        return "--";
      }

      const horas = Math.floor(segundos / 3600);
      const minutos = Math.floor((segundos % 3600) / 60);
      const segsRestantes = Math.round(segundos % 60);

      const partes = [];
      if (horas > 0) {
        partes.push(`${horas}h`);
      }
      partes.push(`${minutos} min`);
      partes.push(`${segsRestantes}s`);

      return partes.join(" ");
    }
  },
  async mounted() {
    await this.getAssuntos();
    await this.getTipoAssuntos();
    await this.getGlobalWatiConfig();
    await this.getEstagios(); 
  },
  components: { ...components, modalRespostas, router }
};
</script>
<style lang="scss">
.scroll-assunto {
  height: 72vh !important;
}
.wati-config-popup {
  .vs-popup {
    width: 900px !important;
    max-width: 95vw !important;
  }
}
thead tr th#center {
  .vs-table-text {
    justify-content: center !important;
  }
}
.cardTable {
  transition-duration: 300ms;
  border-style: solid;
  border-radius: 4px;
  border-color: rgba(211, 211, 211, 0.493);
  border-width: 2px;
  &:hover {
    transition-duration: 555ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(226, 226, 226, 0.25);
  }
}
</style>
